export default {
  methods: {
    onKeyDownCharsFilter: (e, exceptKeys) => {
      if (exceptKeys && exceptKeys.indexOf(e.key) !== -1) {
        return true
      }

      if (/^@|~|\/|'|]|"|\+|#|!|\$|%|\^|&|\*|\(|\)|\s|\|+|\.|\.|:|;|=|\?|<|>|,|`|\||\{|\}|\\$/.test(e.key)) {
        e.preventDefault()
      }
    },

    onKeyDownCharsFilterOnlyLetters: (e, exceptKeys) => {
      if (exceptKeys && exceptKeys.indexOf(e.key) !== -1) {
        return true
      }

      if (!(/[\p{L}]+$/u.test(e.key))) {
        e.preventDefault()
      }
    },

    onKeyDownCharsFilterOnlyNumbers: (e, exceptKeys) => {
      if (exceptKeys && exceptKeys.indexOf(e.key) !== -1) {
        return true
      }

      // Allow copy, paste
      if (e.ctrlKey && ['a', 'c', 'v'].indexOf(e.key) !== -1) {
        return true;
      }

      if (!(/[\d]+$/u.test(e.key))) {
        e.preventDefault()
      }
    },

    onKeyDownCharsFilterNumbersAndLetters: (e, exceptKeys) => {
      if (exceptKeys && exceptKeys.indexOf(e.key) !== -1) {
        return true
      }

      if (!(/[\p{L}\d]+$/u.test(e.key))) {
        e.preventDefault()
      }
    },

    onKeyDownCharsFilterNumbersAndLettersLatin: (e, exceptKeys) => {
      if (exceptKeys && exceptKeys.indexOf(e.key) !== -1) {
        return true
      }

      if (!(/[a-zA-Z\d]+$/u.test(e.key))) {
        e.preventDefault()
      }
    }
  }
}
